import { ActionId, Objective, OnboardingActionMeta, Profile } from './onboarding.types';

export const ACTION_CATALOG: Record<ActionId, OnboardingActionMeta> = {
  put_property_for_sale: {
    id: 'put_property_for_sale',
    timeHint: '5 min',
    label: 'Mettre votre bien en vente',
    description: "Publiez votre bien pour être contacté par des acheteurs potentiels et bénéficier de l'outil transactionnel.",
    ctaLabel: 'Vendre mon bien',
    targetRoute: '/property1',
    isAvailable: true,
    isActivationGoal: true,
    eventType: 'property_published_sale',
  },
  put_property_for_rent: {
    id: 'put_property_for_rent',
    timeHint: '5 min',
    label: 'Mettre votre bien en location',
    description: "Publiez votre bien pour être contacté par des locataires potentiels et bénéficier de l'outil transactionnel.",
    ctaLabel: 'Louer mon bien',
    targetRoute: '/property1',
    isAvailable: true,
    isActivationGoal: true,
    eventType: 'property_published_rent',
  },
  publish_property_directory: {
    id: 'publish_property_directory',
    timeHint: '5 min',
    label: "Publiez votre bien dans l'annuaire",
    description: "En publiant anonymement votre bien sur l'annuaire AnyHomes, vous recevrez régulièrement des sollicitations spontanées.",
    ctaLabel: 'Référencer mon bien',
    targetRoute: '/property1',
    isAvailable: true,
    isActivationGoal: true,
    eventType: 'property_published_directory',
  },
  estimate_property_value: {
    id: 'estimate_property_value',
    timeHint: '2 clics',
    label: 'Tester la valeur de votre bien',
    description: "Avec le Baromètre prix, les membres de la communauté vous disent ce qu'ils paieraient pour votre bien.",
    ctaLabel: 'Lancer une campagne',
    targetRoute: '/social-estimation',
    isAvailable: true,
    eventType: 'p2p_campaign_started',
  },
  consult_transaction_history: {
    id: 'consult_transaction_history',
    timeHint: '2 clics',
    label: "Consulter l'historique des transactions",
    description: 'Consultez les transactions passées dans le secteur pour avoir une idée de la valeur de votre bien.',
    ctaLabel: 'Voir les transactions',
    targetRoute: '/past-transation-list',
    isAvailable: true,
    eventType: 'transaction_history_searched',
  },
  get_targeted_help: {
    id: 'get_targeted_help',
    timeHint: '2 clics',
    label: 'Obtenir une aide ponctuelle et ciblée',
    description: "Faites-vous accompagner par un professionnel de l'immobilier sans commission pour sécuriser votre projet.",
    ctaLabel: 'Voir les services',
    targetRoute: '/marketplace',
    isAvailable: true,
    eventType: 'service_searched',
  },
  learn_real_estate: {
    id: 'learn_real_estate',
    timeHint: '1 clic',
    label: "Formez-vous à l'immobilier",
    description: 'Consultez le Learning center pour découvrir nos conseils et bonnes pratiques pour mener votre projet immobilier seul.',
    ctaLabel: 'Learning center',
    targetRoute: '/learning-center',
    isAvailable: true,
    eventType: 'training_content_viewed',
  },
  compute_financial_score_buy: {
    id: 'compute_financial_score_buy',
    timeHint: '5 min',
    label: 'Calculer mon indice confiance acquéreur',
    description: 'Ce score vous donne accès à des opportunités Off-market et renforce la crédibilité de votre profil auprès des propriétaires.',
    ctaLabel: 'Démarrer le calcul',
    targetRoute: '/buyer-file',
    isAvailable: true,
  },
  compute_financial_score_rent: {
    id: 'compute_financial_score_rent',
    timeHint: '5 min',
    label: 'Calculer son score de crédibilité financière',
    description: 'Ce score vous donne accès à des opportunités Off-market et renforce la crédibilité de votre profil auprès des propriétaires.',
    ctaLabel: 'Démarrer le calcul',
    targetRoute: '/renter-file',
    isAvailable: true,
  },
  compute_financial_score_passive: {
    id: 'compute_financial_score_passive',
    timeHint: '5 min',
    label: 'Calculer son score de crédibilité financière',
    description: 'Ce score vous donne accès à des opportunités Off-market et renforce la crédibilité de votre profil auprès des propriétaires.',
    ctaLabel: 'Démarrer le calcul',
    targetRoute: '/buyer-file',
    isAvailable: true,
  },
  build_seller_dossier: {
    id: 'build_seller_dossier',
    label: 'Constituer dossier vendeur',
    description: 'Anticipez votre vente en constituant les éléments de votre dossier vendeur pour sécuriser votre vente.',
    ctaLabel: 'Mon dossier vendeur',
    targetRoute: '/seller-file',
    isAvailable: true,
    eventType: 'seller_dossier_document_added',
  },
  build_buyer_dossier: {
    id: 'build_buyer_dossier',
    label: 'Constituer dossier acheteur',
    description: 'Anticipez votre achat en constituant les éléments de votre dossier acheteur pour sécuriser votre projet.',
    ctaLabel: 'Mon dossier acheteur',
    targetRoute: '/buyer-file#dossier-acheteur',
    isAvailable: true,
    eventType: 'buyer_dossier_document_added',
  },
  build_tenant_dossier: {
    id: 'build_tenant_dossier',
    label: 'Constituer dossier locataire',
    description: 'Préparez votre location en constituant les éléments de votre dossier locataire.',
    ctaLabel: 'Mon dossier locataire',
    targetRoute: '/renter-file',
    isAvailable: true,
    eventType: 'tenant_dossier_document_added',
  },
  get_personalized_advice: {
    id: 'get_personalized_advice',
    timeHint: '1 clic',
    label: 'Obtenir des conseils personnalisés',
    description: "À chaque étape de votre projet, votre coach immobilier IA vous apporte des réponses et conseils personnalisés 24h/7.",
    ctaLabel: 'Mon coach immo IA',
    targetRoute: '#',
    isAvailable: true,
    eventType: 'coach_interacted',
  },
  peer_estimation: {
    id: 'peer_estimation',
    timeHint: '1 clic',
    label: 'Participer au Baromètre prix',
    description: "Partagez collectivement votre avis sur le prix d'un bien référencé par les membres et sur la valeur perçue.",
    ctaLabel: 'Donner mon avis',
    targetRoute: '/estimation',
    isAvailable: true,
    eventType: 'peer_estimation_submitted',
  },
  search_property_buy: {
    id: 'search_property_buy',
    timeHint: '2 clics',
    label: 'Rechercher un bien à acheter',
    description: "Parcourez la liste des biens immobiliers en vente dans l'annuaire pour trouver votre futur bien immobilier.",
    ctaLabel: 'Rechercher',
    targetRoute: '/properties',
    isAvailable: true,
    isActivationGoal: true,
    eventType: 'property_searched_sale',
  },
  search_property_rent: {
    id: 'search_property_rent',
    timeHint: '2 clics',
    label: 'Rechercher un bien à louer',
    description: "Parcourez la liste des biens à louer dans l'annuaire pour trouver votre futur logement.",
    ctaLabel: 'Rechercher',
    targetRoute: '/properties',
    isAvailable: true,
    isActivationGoal: true,
    eventType: 'property_searched_rent',
  },
  find_professional: {
    id: 'find_professional',
    timeHint: '2 clics',
    label: 'Trouver un professionnel',
    description: "Faites-vous accompagner par un professionnel pour sécuriser votre achat ou votre location immobilière.",
    ctaLabel: 'Trouver un Pro',
    targetRoute: '/prolist',
    isAvailable: true,
    eventType: 'professional_searched',
  },
  browse_property_directory: {
    id: 'browse_property_directory',
    timeHint: '2 clics',
    label: "Parcourir l'annuaire des biens immobiliers",
    description: "L'annuaire vous permet de trouver le bien que vous achetez ou louerez dans plusieurs mois ou années.",
    ctaLabel: "Parcourir l'annuaire",
    targetRoute: '/properties?propertyType=directory',
    isAvailable: true,
    isActivationGoal: true,
    eventType: 'directory_browsed',
  },
  follow_property: {
    id: 'follow_property',
    timeHint: '2 clics',
    label: 'Suivre un bien immobilier',
    description: "Trouvez un bien dans l'annuaire et suivez son évolution pour ne pas manquer l'opportunité.",
    ctaLabel: 'Rechercher des biens',
    targetRoute: '/properties',
    isAvailable: true,
    eventType: 'property_followed',
  },
  contact_owner_agency: {
    id: 'contact_owner_agency',
    timeHint: '3 clics',
    label: "Contacter un propriétaire ou une agence",
    description: "Depuis la fiche d'un bien, initiez une conversation avec un propriétaire ou une agence.",
    ctaLabel: 'Trouver un bien',
    targetRoute: '/properties',
    isAvailable: true,
    eventType: 'owner_contacted',
  },
  activate_ai_assistant: {
    id: 'activate_ai_assistant',
    timeHint: '2 min',
    label: 'Activer votre assistant immobilier IA',
    description: "Confiez les échanges répétitifs à votre assistant : il qualifie les demandes et analyse des centaines de biens pour vous aider à décider.",
    ctaLabel: 'Activer mon assistant',
    targetRoute: '#',
    isAvailable: true,
    isActivationGoal: true,
    eventType: 'assistant_activated',
  },
  dream_bigger_projection: {
    id: 'dream_bigger_projection',
    timeHint: '3 min',
    label: 'Faire une projection « Rêvons plus grand »',
    description: "Projetez votre avenir immobilier : indiquez vos revenus, votre apport et votre horizon pour découvrir le bien que vous pourriez viser et les biens correspondants.",
    ctaLabel: 'Faire ma projection',
    targetRoute: '/revons-plus-grand',
    isAvailable: true,
    eventType: 'dream_bigger_projection_done',
  },
  repere_simulation: {
    id: 'repere_simulation',
    timeHint: '2 clics',
    label: 'Consulter vos repères immo',
    description: "Lancez une projection complète : valeur de votre bien, prix du marché, DPE, taxes, frais de notaire et professionnels autour de vous.",
    ctaLabel: 'Faire une simulation',
    targetRoute: '/boite-a-outils',
    isAvailable: true,
    eventType: 'repere_simulation_done',
  },
};

type ConfigKey = `${Profile}_${Objective}`;

export const CONFIGURATION_MATRIX: Partial<Record<ConfigKey, ActionId[]>> = {
  owner_sell: [
    'put_property_for_sale',
    'estimate_property_value',
    'consult_transaction_history',
    'get_targeted_help',
    'learn_real_estate',
    'build_seller_dossier',
    'get_personalized_advice',
    'peer_estimation',
    'repere_simulation',
    'activate_ai_assistant',
  ],
  owner_rent: [
    'put_property_for_rent',
    'estimate_property_value',
    'get_targeted_help',
    'learn_real_estate',
    'get_personalized_advice',
    'peer_estimation',
    'repere_simulation',
    'activate_ai_assistant',
  ],
  owner_increase_value: [
    'publish_property_directory',
    'estimate_property_value',
    'learn_real_estate',
    'get_personalized_advice',
    'peer_estimation',
  ],
  searcher_active_buy: [
    'compute_financial_score_buy',
    'search_property_buy',
    'get_targeted_help',
    'learn_real_estate',
    'build_buyer_dossier',
    'get_personalized_advice',
    'peer_estimation',
    'repere_simulation',
    'find_professional',
    'activate_ai_assistant',
  ],
  searcher_active_rent: [
    'compute_financial_score_rent',
    'search_property_rent',
    'get_targeted_help',
    'learn_real_estate',
    'build_tenant_dossier',
    'get_personalized_advice',
    'peer_estimation',
    'repere_simulation',
    'find_professional',
    'activate_ai_assistant',
  ],
  searcher_passive: [
    'compute_financial_score_passive',
    'browse_property_directory',
    'publish_property_directory',
    'learn_real_estate',
    'get_personalized_advice',
    'peer_estimation',
    'follow_property',
    'contact_owner_agency',
    'dream_bigger_projection',
  ],
};

export function getActionsForConfig(profile: Profile, objective: Objective): OnboardingActionMeta[] {
  const key = `${profile}_${objective}` as ConfigKey;
  const ids = CONFIGURATION_MATRIX[key] ?? [];
  const coachRoute = profile === 'owner'
    ? '/real-estate-transaction-owner'
    : '/real-estate-transaction-searcher';
  const isOwner = profile === 'owner';
  return ids.map((id) => {
    const action = ACTION_CATALOG[id];
    if (id === 'get_personalized_advice') {
      return { ...action, targetRoute: coachRoute };
    }
    if (id === 'activate_ai_assistant') {
      return {
        ...action,
        // Carte « Activer votre assistant immobilier IA » : contenu et cible
        // varient selon le persona (assistant propriétaire vs recherche).
        description: isOwner
          ? 'Confiez les échanges répétitifs avec vos prospects à votre assistant : il qualifie les demandes, répond aux questions sur votre bien, propose les créneaux de visite et partage les documents autorisés.'
          : "Votre assistant analyse des centaines de biens pour vous : il élimine ceux qui ne correspondent pas à votre projet, pose les bonnes questions au propriétaire et produit des rapports pour éclairer votre décision.",
        targetRoute: isOwner ? '/agent-autonome/assign' : '/assistant-candidat/assign',
      };
    }
    return action;
  });
}
